(ns shared.core.amelia-light.components.dialog.data
  (:require [shared.core.reactive :as re]))

(def root-path [:dialog])
(def active-path (conj root-path :active))

(defn active-dialogs [db]
  (get-in db active-path []))

(re/reg-event-db
  :dialog/show re/middleware
  (fn [db [dialog]]
    (re/dispatch [:keybind/pause-current-route-bindings])
    (assoc-in db active-path [dialog])))

(re/reg-event-db
  :dialog/show-with-form-init re/middleware
  (fn [db [dialog form-path form-vals]]
    (re/dispatch [:dialog/show dialog])
    (re/dispatch [:form/init form-path form-vals])
    db))

(re/reg-event-db
  :dialog/show-stacked re/middleware
  (fn [db [dialog]]
    (re/dispatch [:keybind/pause-current-route-bindings])
    (assoc-in db active-path (-> (active-dialogs db) (concat [dialog]) (vec)))))

(re/reg-event-db
  :dialog/hide re/middleware
  (fn [db]
    (re/dispatch [:keybind/resume-current-route-bindings])
    (assoc-in db active-path (-> (active-dialogs db) (drop-last) (vec)))))

(re/reg-event-db
  :dialog/scroll-to-top re/middleware
  (fn [db]
    (when-let [dialog-el (.querySelector js/document "[data-slot=\"dialog-body\"]")]
      (set! (.-scrollTop dialog-el) 0))
    db))

(defn active-dialog [db]
  (some-> (active-dialogs db) (last)))

(re/reg-sub :dialog/active- active-dialog)

(re/reg-sub :dialog/all-active- active-dialogs)
